import React, { useState } from 'react';
import { Box, Menu, MenuItem, Typography } from '@mui/material';
import { addTransparency, darkenColor } from '../../../application/styles/colorStyles';

export interface LabelOption {
  value: string;
  label: string;
  icon?: string;
  color: string;
}

interface LabelProps {
  options: LabelOption[];
  currentValue: string;
  onOptionChanged?: (value: string) => void;
}

const Label: React.FC<LabelProps> = ({ options, currentValue, onOptionChanged }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [open, setOpen] = useState(false);

  const getCurrentOption = () => {
    return options.find(option => option.value === currentValue) || options[0];
  };

  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
    setOpen(true);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setOpen(false);
  };

  const handleOptionSelect = (event: React.MouseEvent<HTMLLIElement>, value: string) => {
    event.stopPropagation();
    onOptionChanged?.(value);
    handleClose();
  };

  const currentOption = getCurrentOption();


  return (
    <>
      <Box
        onClick={onOptionChanged ? handleClick : undefined}
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 1,
          px: 1.5,
          py: 0.5,
          borderRadius: 1,
          cursor: 'pointer',
          transition: 'all 0.2s',
          '&:hover': {
            opacity: 0.8
          },
          backgroundColor: addTransparency(currentOption.color),
          color: darkenColor(currentOption.color),
          borderColor: currentOption.color,
          borderWidth: 1,
          borderStyle: 'solid',
        }}
      >
        {currentOption.icon && <img src={currentOption.icon} alt={currentOption.label} width={16} height={16} />}
        <Typography variant="body2" noWrap>
          {currentOption.label}
        </Typography>
      </Box>

      {onOptionChanged && (
        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
        >
          {options.map((option) => (
            <MenuItem
              key={option.value}
              onClick={(event) => handleOptionSelect(event, option.value)}
              selected={option.value === currentValue}
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1
              }}
            >
              {option.icon && (
                <img
                  src={option.icon}
                  alt={option.label}
                  width={16}
                  height={16}
                />
              )}
              <Typography variant="body2" noWrap>
                {option.label}
              </Typography>
            </MenuItem>
          ))}
        </Menu>
      )}
    </>
  );
};

export default Label; 